import dayjs from 'dayjs'
import { GRANULARITY_DURATION } from 'constants/datetime.ts'
import { capitalizeFirstLetter } from 'utils/format.ts'
import { formatChartDateLabel } from 'utils/chartjs.ts'
import { addBelgianTime, formatHour, isIntradayGranularity } from 'utils/date.ts'
import { Granularity } from 'types/contracts.ts'

/**
 * Checks whether the period of the given date still has to end, e.g. the running month in a year view. Their price is
 * either provisional (partly known) or not known at all
 *
 * @param {string} date
 * @param {Granularity} granularity
 * @returns {boolean}
 */
export const isUnfinishedPeriod = (date: string, granularity: Granularity): boolean => {
  const { amount, unit } = GRANULARITY_DURATION[granularity]

  return addBelgianTime(date, amount, unit).isAfter(dayjs())
}

/**
 * Returns the label of the period of the given date: its timeframe for granularities within a day (e.g. 8:00 - 9:00),
 * the full period otherwise (e.g. augustus or 3 augustus 2026)
 *
 * @param {string} date
 * @param {Granularity} granularity
 * @returns {string}
 */
export const formatPeriodLabel = (date: string, granularity: Granularity): string => {
  if (isIntradayGranularity(granularity)) {
    const { amount, unit } = GRANULARITY_DURATION[granularity]

    return `${formatHour(date)} - ${formatHour(addBelgianTime(date, amount, unit))}`
  }

  return capitalizeFirstLetter(formatChartDateLabel(date, granularity, true))
}
